import React from 'react';
import { CouponType, messageType } from './src-clients-couponCallout.client.types.js';
import { useScopedBaseConfig } from './src-contexts-CouponCalloutConfig.context.js';
import { useCouponDetailsStore } from './src-store-couponDetails.store.js';
import { AppliedCouponDisplay } from './src-components-CouponDisplay-AppliedCouponDisplay.js';
import { PMTDisplayMessage } from './src-components-CouponDisplay-PMTDisplayMessage.js';
import { PriceDisplayMessage } from './src-components-CouponDisplay-PriceDisplayMessage.js';

const CouponCalloutDisplay = ({
  queryKey,
  asLowAsPrice
}) => {
  const { pageId } = useScopedBaseConfig();
  const productCouponDetails = useCouponDetailsStore((state) => state.data[pageId]?.couponDetails?.productCouponData?.[queryKey]);
  const pricingContext = useCouponDetailsStore((state) => state.pricingContext);
  const isAppliedStateCoupon = !!pricingContext?.value?.couponCode;
  if (isAppliedStateCoupon) {
    return /* @__PURE__ */ React.createElement(AppliedCouponDisplay, { queryKey });
  }
  if (productCouponDetails?.couponType === CouponType.Product && !productCouponDetails?.isCouponPriceBetterThanOffer) {
    return null;
  }
  switch (productCouponDetails?.messageType) {
    case messageType.PRICES:
      return /* @__PURE__ */ React.createElement(PriceDisplayMessage, { queryKey, asLowAsPrice });
    default:
      return /* @__PURE__ */ React.createElement(PMTDisplayMessage, { queryKey });
  }
};

export { CouponCalloutDisplay };
//# sourceMappingURL=src-components-CouponDisplay-CouponCalloutDisplay.js.map
